export default __webpack_public_path__ + "static/media/ruby.dc9f0e28.svg";